export default "__VITE_ASSET__BvC$2CgD__"